import { boolean } from "yup";
import { axiosInstance } from ".";
import {
  Coach,
  DefaultCvInfo,
  LinkedInSubmitData,
} from "../pages/private/myArea/menus/assessments/LinkedInPackage";

export const fetchLinkedInCredits = async (): Promise<any[]> => {
  try {
    const response = await axiosInstance.get("/linkedin-package/credits");

    return response.data || [];
  } catch (error) {
    console.error("Error fetching linkedin credits:", error);
    return [];
  }
};

export const fetchDefaultCvInfo = async (): Promise<DefaultCvInfo | null> => {
  try {
    // Match backend endpoint and expected response structure
    const response = await axiosInstance.get<{
      hasDefaultCv: boolean;
      cvName?: string;
      cvKey?: string;
    }>("/linkedin-package/default-cv");
    if (response.data && typeof response.data.hasDefaultCv === "boolean") {
      return response.data;
    }
    console.warn(
      "Unexpected response format from /linkedin-package/default-cv:",
      response.data
    );
    return { hasDefaultCv: false };
  } catch (error) {
    console.error("Error fetching default cv info:", error);
    return null;
  }
};

export const checkIfCreditExists = async (): Promise<any> => {
  try {
    const response = await axiosInstance.get<{ exists: boolean }>(
      "/linkedin-package/check"
    );

    return response.data;
  } catch (error) {
    console.error("Error checking for existing LinkedIn credit:", error);
  }
};

export const fetchCoaches = async (): Promise<Coach[]> => {
  try {
    const response = await axiosInstance.get<Coach[]>(
      "/linkedin-package/guides-coaches"
    );
    return response.data || [];
  } catch (error) {
    console.error("Error fetching available coaches/guides:", error);
    return [];
  }
};

export const submitLinkedInPackageRequest = async (
  data: LinkedInSubmitData
): Promise<any> => {
  const formData = new FormData();
  formData.append("linkedinUrl", data.linkedInUrl);
  formData.append("selectedPersonId", data.coachId);
  if (data.useDefaultCv) {
    formData.append("useDefaultCv", "true");
  } else if (data.proceedWithoutCv) {
    formData.append("proceedWithoutCv", "true");
  }

  if (!data.useDefaultCv && !data.proceedWithoutCv && data.cvFile) {
    formData.append("cvFile", data.cvFile, data.cvFile.name);
  }

  try {
    const response = await axiosInstance.post(
      "/linkedin-package/create",
      formData,
      {
        headers: {
          "Content-Type": "multipart/form-data",
        },
      }
    );
    return response.data;
  } catch (error: any) {
    console.error("Error submitting LinkedIn package request:", error);
    const errorMessage =
      error.response?.data?.message ||
      error.message ||
      "An unknown error occurred during submission.";
    throw new Error(errorMessage);
  }
};
